<template>
  <footer class="footer-section">
    <div class="container pt-5">
      <b-row>
        <b-col md="6" lg="4">
          <div class="footer-col">
            <div class="title">Popular Courses</div>
            <b-nav vertical class>
              <b-nav-item
                v-for="popularCourse in getCategoryData"
                :key="popularCourse.name"
                :to="{
                  path: '/courses',
                  query: {
                    categoryName: popularCourse.name,
                    categoryId: popularCourse.category_id
                  }
                }"
                >{{ popularCourse.name }}
              </b-nav-item>
            </b-nav>
          </div>
        </b-col>
        <b-col md="6" lg="3">
          <div class="footer-col">
            <div class="title">About Us</div>
            <b-nav vertical class>
              <b-nav-item to="/about">
                About Us
              </b-nav-item>
              <b-nav-item>
                Press Center
              </b-nav-item>
              <b-nav-item to="/become_a_teacher">
                Become an Instructor
              </b-nav-item>
              <b-nav-item to="/request_course">
                Request a Course
              </b-nav-item>
              <!--<b-nav-item>-->
              <!--Blog-->
              <!--</b-nav-item>-->
            </b-nav>
          </div>
        </b-col>
        <b-col md="6" lg="3">
          <div class="footer-col">
            <div class="title">Support</div>
            <b-nav vertical class>
              <b-nav-item>
                Support
              </b-nav-item>
              <b-nav-item to="/contact-us">
                Contact Us
              </b-nav-item>
              <b-nav-item to="/help">
                Popular Questions
              </b-nav-item>
              <b-nav-item>
                Site feedback
              </b-nav-item>
            </b-nav>
          </div>
        </b-col>
        <b-col md="6" lg="2">
          <div class="footer-col">
            <div class="title">Follow Us</div>
            <b-nav vertical class>
              <b-nav-item
                v-for="(connect, index) in connects"
                :key="index"
                :href="connect.link"
                target="_blank"
              >
                <font-awesome-icon :icon="['fab', connect.icon]" />
                <span>{{ connect.text }}</span>
              </b-nav-item>
            </b-nav>
          </div>
        </b-col>
      </b-row>
      <hr class="white" />
      <div class="copyright-section row">
        <p class="col">
          Copyright &copy; {{ new Date().getFullYear() }}, Edfore. All Rights
          Reserved
        </p>
        <p class="col text-right"> Version : {{ version }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import { store } from "../../store/store";

export default {
  name: "main-footer",
  computed: {
    ...mapGetters("category", ["getCategoryData"])
  },
  data() {
    return {
        version:"",
      popularCourses: [
        "Math",
        "Physics",
        "English",
        "Malayalam",
        "Biology",
        "Chemistry",
        "History",
        "Music"
      ],
      aboutUs: ["About Us", "Press Center", "Become an Instructor", "Blog"],
      supports: ["Support", "Contact Us", "Popular Questions", "Site feedback"],
      connects: [
        {
          icon: "facebook-square",
          link: "https://www.facebook.com",
          text: "Facebook"
        },
        {
          icon: "twitter-square",
          link: "https://twitter.com",
          text: "Twitter"
        },
        {
          icon: "linkedin-in",
          link: "https://www.linkedin.com",
          text: "LinkedIn"
        },
        {
          icon: "instagram",
          link: "https://www.instagram.com/",
          text: "Instagram"
        }
      ]
    };
  },
  methods: {
    goToCategory(category) {
      this.$router.push({
        path: "/courses",
        query: {
          categoryName: category.name,
          categoryId: category.category_id
        }
      });
    }
  },
    mounted(){
      this.version = store.state.version
    }
};
</script>

<style></style>
